"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("@material-ui/core/colors");
const react_1 = __importStar(require("react"));
const env_1 = require("../../helpers/env");
const colorForInitials = [
    colors_1.pink[400],
    colors_1.purple[400],
    colors_1.indigo[400],
    colors_1.cyan[400],
    colors_1.teal[400],
    colors_1.green[400],
    colors_1.yellow[700],
    colors_1.lime[700],
    colors_1.amber[900],
    colors_1.blue[400],
    colors_1.red[500],
    colors_1.blueGrey[500],
    colors_1.brown[500],
];
function getColorForInitial(name) {
    if (name.length === 0) {
        return colorForInitials[0].slice(1);
    }
    return colorForInitials[Math.abs((name.toLowerCase().charCodeAt(0) - 'a'.charCodeAt(0)) % colorForInitials.length)].slice(1);
}
/**
 * Used to render a user avatar.
 * If URL is valid: display the image from the URL. Otherwise, use UI Avatar to generate from the name.
 */
const UserAvatar = ({ size, url, name, rounded }) => {
    const fallbackImageUrl = `https://ui-avatars.com/api/?name=${name}&size=${size}&color=fff&font-size=0.4&background=${getColorForInitial(name)}`;
    const [imageUrl, setImageUrl] = react_1.useState(fallbackImageUrl);
    // TODO: fix for the case where image may remain when url changes.
    // https://github.com/opendoor-labs/code/pull/28852#discussion_r606104061
    react_1.useEffect(() => {
        let reloaded = false;
        if (!url) {
            return;
        }
        if (typeof url === 'string') {
            setImageUrl(url);
            return;
        }
        url()
            .then((url) => {
            if (!reloaded) {
                setImageUrl(url);
            }
        })
            .catch((error) => {
            if (env_1.IS_DEV) {
                console.log(error);
            }
        });
        return () => {
            reloaded = true;
        };
    }, [url]);
    const onError = () => {
        setImageUrl(fallbackImageUrl);
    };
    return (react_1.default.createElement("img", { src: imageUrl, width: size, className: rounded ? 'bo-radius-circle' : '', alt: name, onError: onError }));
};
exports.default = UserAvatar;
